import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=3c0222f2&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=js&"
export * from "./Blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0222f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0222f2')) {
      api.createRecord('3c0222f2', component.options)
    } else {
      api.reload('3c0222f2', component.options)
    }
    module.hot.accept("./Blank.vue?vue&type=template&id=3c0222f2&scoped=true&", function () {
      api.rerender('3c0222f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/Blank.vue"
export default component.exports